import { ILegacyDuTypeFormValueType } from "../Types/legacyDuTypeFormProps"
import { ILegacyTypeError } from "./ILegacyDuTypeFormField"

export interface IInitialStateLegacyType {
  values: ILegacyDuTypeFormValueType
  errors: ILegacyTypeError
  submitted: boolean
  dirty: boolean
  setPopup: boolean
  isFormValid: boolean
}

export const iInitialStateLegacyType: IInitialStateLegacyType = {
  values: {
    containerType: "",
    containerName: "",
    description: "",
    customerType: "",
    isDefault: false
  },
  errors: {
    containerType: "",
    containerName: "",
    description: "",
    customerType: "",
    isDefault: ""
  },
  submitted: false,
  dirty: false,
  setPopup: false,
  isFormValid: false
}